import React, { useState } from "react";
import { Button,ComboBox,DatePicker,Icon,TextField, TooltipHost,IDatePickerStrings, Spinner} from "@fluentui/react";
import "./collaboratorCreateView.css";
import { useEffect} from "react";
import { FieldErrors, FieldValues, UseFormRegister, UseFormSetValue, UseFormWatch, ValidationRule } from "react-hook-form";
import { DateCustom } from "../../../lib/DateCustom";
import { DateTime } from "luxon";
import formatearFecha from "../../../common/formatDate";
import TimeTaxSupportSystemClient from "../../../system";
import { User } from "../../../system/User";
import { IProfileUser } from "../../../system/collaborators/CollaboratorSystem";
import { t } from "i18next";


export const spanishDatePickerStrings: IDatePickerStrings = {
  months: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],

  shortMonths: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],

  days: [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ],

  shortDays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],

  goToToday: 'Ir a hoy',
  prevMonthAriaLabel: 'Ir al mes anterior',
  nextMonthAriaLabel: 'Ir al mes siguiente',
  prevYearAriaLabel: 'Ir al año anterior',
  nextYearAriaLabel: 'Ir al año siguiente',
  closeButtonAriaLabel: 'Cerrar',
  isRequiredErrorMessage: 'Campo obligatorio',
  invalidInputErrorMessage: t('Formato de fecha no válido.'),
};

export interface IHeaderCollaboratorCreate {
  setviewcreate: (data: number) => void;
  setToasError : (data: boolean) => void;
  errors: FieldErrors<FieldValues>
}
export interface IcustomTextFile{
  placeholder:string;
  label:string;
  type:string;
  width:string;
  height:string;
  name:string;
  register: UseFormRegister<FieldValues>;
  minLength?:number | undefined;
  pattern?:ValidationRule<RegExp> | undefined;
  maxLength?:number | undefined;
} 
export interface IInformacionGeneral{
  register: UseFormRegister<FieldValues>;
  errors:FieldErrors<FieldValues>;
  setValue:UseFormSetValue<FieldValues>;
  watch: UseFormWatch<FieldValues>
  system?:TimeTaxSupportSystemClient | undefined;
  user?:User;
  changeBlockUI?: (change: boolean) => void;
}

export interface Idirection {
  key: string;
  text: string;
  nor_nivel: string;
  nor_padre: string;
}

export default function HeaderCollaboratorCreate({
  setviewcreate,setToasError,errors
}: IHeaderCollaboratorCreate) {

  const oneMistake = ()=>{
   if(!!errors){
    setToasError(true);
    setTimeout(() => {
      setToasError(false);
    }, 5000); 
   }
  }
  return (
    <div className="collaborator_create_hader_buton">
      <span>
        <Icon
          iconName="ReminderPerson"
          style={{ color: "#0078D4", marginRight: "5px" }}
        />
        <span>{t('Colaboradores')}</span>
      </span>
      <Button className="Button_view" type="submit" onClick={()=>oneMistake()}>
        <Icon iconName="save" style={{ marginRight: "5px" }} />
        <span>{t('Guardar')}</span>
      </Button>
      <Button className="Button_back" onClick={() => setviewcreate(0)}>
        <Icon
          iconName="back"
          style={{ color: "#0078D4", marginRight: "3px" }}
        />
        <span>{t('Volver')}</span>
      </Button>
    </div>
  );
}

export const InformacionGeneral = ({register,errors,setValue,user,system, changeBlockUI}:IInformacionGeneral) => {

  const [lisProfileUser , setListProfileUser] = useState<IProfileUser[]>();

  const handleDateChange = (date,name:string) => {
    if(!date)return;
    register(name,{required:true})
    const ddat = formatearFecha(date)
    setValue(name,ddat);
  };

  const typeUserVerif = ():boolean=>{
    const typeUser = user?.getProfile().getName();
    if((typeUser === 'Power User') || typeUser === 'Admin User' || typeUser === 'Admin TTS'){
      register("selecusuarios",{required:true});
        return true;
    }else{
      register("selecusuarios",{required:false});
       return false
      };
  }

  const getProfileUser = async ()=>{
    changeBlockUI?.(true)
    const result = await system?.getCollaboratorSystem().getProfileUser();
    setListProfileUser(result || []);
    changeBlockUI?.(false)
  }

  useEffect(()=>{
    getProfileUser()
    register("fechaingreso",{required:true});
  },[])
    
  return (
    <div className="form_informacion_general">
      <p className="titulo_form_create">
        <Icon iconName="ContactCard" style={{fontSize:"30px"}} />
        {t('Información general.')}
      </p>
    <div className="form_informacion_general_cuerpo">
      <CustomTextFile key="001" width="158px" height="14px" label={t("Código SAP")}
        placeholder={t("Escriba el código SAP")} type="text" name="codigosap" register={register} pattern={/^\d+$/} maxLength={10} />
      {errors?.codigosap?.type === "required" && <span className="error_stilos">{t("El código SAP no puede ser vacío.")}</span>}
      {errors?.codigosap?.type === "pattern" && <span className="error_stilos">{t("Este campo solo permite números.")}</span>}
      {errors?.codigosap?.type === "maxLength" && <span className="error_stilos">{t("El código SAP no debe contener mas de 10 números.")}</span>}

      <CustomTextFile key="002" width="158px" height="14px" label={t("Documento")}
        placeholder={t("Escriba el documento")} type="text" name="dni" register={register} maxLength={13} pattern={/^[a-zA-Z0-9]+$/} />
      {errors?.dni?.type === "required" && <span className="error_stilos">{t("El documento no puede ser vacío.")}</span>}
      {errors?.dni?.type === "maxLength" && <span className="error_stilos">{t("El documento no debe contener más de 13 caracteres.")}</span>}
      {errors?.dni?.type === "pattern" && <span className="error_stilos">{t("Este campo solo permite letras y números, sin caracteres especiales.")}</span>}

      <CustomTextFile key="003" width="302px" height="14px" label={t("Nombre")}
        placeholder={t("Escriba el nombre del colaborador")} type="text" name="nombre" register={register}
        pattern={/^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+(?: [a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)*$/} maxLength={150} />
      {errors?.nombre?.type === "required" && <span className="error_stilos">{t("El nombre del colaborador no puede ser vacío.")}</span>}
      {errors?.nombre?.type === "pattern" && <span className="error_stilos">{t("El nombre no debe contener números.")}</span>}
      {errors?.nombre?.type === "maxLength" && <span className="error_stilos">{t("El nombre no debe contener mas de 150 caracteres.")}</span>}

      <CustomTextFile key="004" width="302px" height="14px" label={t("Apellidos")}
        placeholder={t("Escriba los apellidos del colaborador")} type="text" name="apellido" register={register}
        pattern={/^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+(?: [a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)*$/} maxLength={150} />
      {errors?.apellido?.type === "required" && <span className="error_stilos">{t("El apellido no puede ser vacío.")}</span>}
      {errors?.apellido?.type === "pattern" && <span className="error_stilos">{t("El apellido no debe contener números.")}</span>}
      {errors?.apellido?.type === "maxLength" && <span className="error_stilos">{t("El apellido no debe contener mas de 150 caracteres.")}</span>}

      <CustomTextFile key="005" width="302px" height="14px" label={t("Email")}
        placeholder={t("Escriba el email del colaborador")} type="text" name="email" register={register}
        pattern={/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/} maxLength={150} />
      {errors?.email?.type === "required" && <span className="error_stilos">{t("El email no puede ser vacío.")}</span>}
      {errors?.email?.type === "pattern" && <span className="error_stilos">{t("Ingresa un email válido.")}</span>}
      {errors?.email?.type === "maxLength" && <span className="error_stilos">{t("El email no debe contener mas de 150 caracteres.")}</span>}

      <div style={{ display: "flex", flexDirection: "column" }}>
        <span className="date_derecho_form">
          <DatePicker strings={spanishDatePickerStrings} allowTextInput formatDate={DateCustom.formatDateForDatePicker} parseDateFromString={DateCustom.parseDateForDatePicker}
            label={t("Fecha de Ingreso")} placeholder={t("Seleccione la fecha de ingreso")}
            className="label_reusable" styles={{ root: { width: "220px" } }} onSelectDate={(date) => handleDateChange(date, "fechaingreso")} />
          {errors.fechaingreso && <span className="error_stilos_practicante">{t("La fecha de ingreso no puede ser vacío.")}</span>}
        </span>

        {typeUserVerif() && <span className="date_derecho_form">
          <TooltipHost content={t("Seleccione el tipo de usuario")}>
            {lisProfileUser ? (
              <ComboBox className="label_reusable"
                placeholder={t("Seleccione el tipo de usuario.")}
                label={t("Seleccione el tipo de usuario")}
                options={lisProfileUser || []}
                styles={{ root: { width: "220px" } }}
                onChange={(event, option) => setValue("selecusuarios", option)} />
              ) : (
                <Spinner styles={{ root: { marginTop: 20}}}/>
            )}
          </TooltipHost>
          {errors.selecusuarios && <span className="error_stilos_practicante">{t("El tipo de usuario no puede ser vacío.")}</span>}
        </span>}
      </div>
    </div>
    </div>
  );
};


export function CustomTextFile ({placeholder,label,type,width,height, name,register,
  minLength=undefined,pattern=undefined,maxLength=undefined}:IcustomTextFile){
  return (
    <span className="input_reusable">
      <TextField
      styles={{root:{width:width, height:height}}}
        placeholder={placeholder}
        label={label}
        type={type}
       {...register(name,{required:true,minLength,pattern,maxLength})}
      />
    </span>
  );
} 

export function getCurrentDateTime() {
  // Obtiene la fecha y hora actual en la zona horaria local
  return DateTime.local().toJSDate();
}